// vim: set ts=2 sts=2 sw=2 et:

import { PlatformLiveAttemptClock } from "./platformLiveProtocol";

interface PlatformLiveClockSnapshot {
  attemptClock: PlatformLiveAttemptClock | null;
  serverNowMs: number | null;
  receivedAtMs: number | null;
}

interface PlatformLiveTimeSnapshot {
  serverNowMs: number | null;
  receivedAtMs: number | null;
}

export const getEffectiveServerNowMs = (
  snapshot: PlatformLiveTimeSnapshot,
  clientNowMs: number = Date.now(),
): number | null => {
  if (snapshot.serverNowMs === null || snapshot.receivedAtMs === null) {
    return null;
  }

  const elapsedClientMs = Math.max(0, clientNowMs - snapshot.receivedAtMs);
  return snapshot.serverNowMs + elapsedClientMs;
};

export const getRemainingClockSeconds = (
  snapshot: PlatformLiveClockSnapshot,
  clientNowMs: number = Date.now(),
): number | null => {
  if (snapshot.attemptClock === null || snapshot.serverNowMs === null || snapshot.receivedAtMs === null) {
    return null;
  }

  // Paused: freeze the countdown at the stored remaining ms on EVERY viewer (operator/judge/spectator/
  // streaming all call this), regardless of wall-clock drift.
  if (snapshot.attemptClock.pausedRemainingMs !== undefined) {
    return Math.ceil(Math.max(0, snapshot.attemptClock.pausedRemainingMs) / 1_000);
  }

  const effectiveServerNowMs = getEffectiveServerNowMs(snapshot, clientNowMs);
  if (effectiveServerNowMs === null) {
    return null;
  }

  const remainingMs = Math.max(0, snapshot.attemptClock.endsAtMs - effectiveServerNowMs);
  return Math.ceil(remainingMs / 1_000);
};
